import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Typography
} from '@mui/material';

const formatSceneDate = (dateValue) => {
  if (!dateValue) return 'Unknown date';
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? 'Unknown date' : date.toLocaleDateString('en-CA');
};

function TileGallery({ scenes, selectedSceneIds, onToggleScene }) {
  if (!scenes.length) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
        No images found for this boundary and date range.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, mt: 1.5 }}>
      {scenes.map((scene) => {
        const cloudCover = Number(scene.cloudCover);
        const aoiOverlapPct = Number(scene.aoiOverlapPct);
        const isCloudy = Number.isFinite(cloudCover) && cloudCover > 50;
        const isSelected = selectedSceneIds.includes(scene.id);

        return (
          <Box
            key={scene.id}
            sx={{
              border: '1px solid',
              borderColor: isCloudy ? 'error.light' : 'divider',
              borderRadius: 2,
              overflow: 'hidden',
              backgroundColor: isCloudy ? 'rgba(244, 67, 54, 0.05)' : 'background.paper'
            }}
          >
            <Box
              sx={{
                height: 115,
                backgroundColor: 'grey.100',
                backgroundImage: scene.thumbnailUrl ? `url(${scene.thumbnailUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
              }}
            >
              {isCloudy && (
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(244, 67, 54, 0.18)'
                  }}
                />
              )}
            </Box>

            <Box sx={{ p: 1.25 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mb: 0.75 }}>
                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                  {formatSceneDate(scene.date)}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  {Number.isFinite(aoiOverlapPct) && (
                    <Chip
                      size="small"
                      variant="outlined"
                      label={`${aoiOverlapPct.toFixed(0)}% AOI`}
                      sx={{ height: 20, fontSize: '0.68rem' }}
                    />
                  )}
                  <Chip
                    size="small"
                    color={isCloudy ? 'error' : 'success'}
                    label={`${Number.isFinite(cloudCover) ? cloudCover.toFixed(0) : 'N/A'}% cloud`}
                    sx={{ height: 20, fontSize: '0.68rem' }}
                  />
                </Box>
              </Box>

              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Checkbox
                    size="small"
                    checked={isSelected}
                    onChange={() => onToggleScene(scene)}
                  />
                }
                label={<Typography variant="caption">Selected</Typography>}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default TileGallery;
